export default "__VITE_ASSET__nZ_9Jpjw__"